import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Package, ChevronRight } from "lucide-react";
import api from "../lib/api";

const STATUS_COLORS = {
  placed: "#D4AF37",
  packed: "#D4AF37",
  shipped: "#0A1F44",
  on_rikshaw: "#E91E63",
  delivered: "#16a34a",
  cancelled: "#9ca3af",
  returned: "#9ca3af",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/orders")
      .then((r) => setOrders(r.data.items || []))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <p className="label-overline text-jow-navy/55" data-testid="orders-loading">Loading orders…</p>;
  }

  if (orders.length === 0) {
    return (
      <div className="bg-white border border-jow-navy/10 p-10 text-center" data-testid="orders-empty">
        <Package size={28} className="text-jow-gold mx-auto" />
        <p className="font-display text-2xl text-jow-navy mt-4">No orders yet.</p>
        <p className="text-sm text-jow-navy/55 mt-2">When you place your first order, it'll live here.</p>
        <Link to="/shop" className="btn-primary-jow mt-7 inline-flex">Visit the atelier</Link>
      </div>
    );
  }

  return (
    <div className="space-y-5" data-testid="orders-page">
      <div>
        <span className="label-overline text-jow-gold">Orders</span>
        <h2 className="font-display text-3xl text-jow-navy mt-1">Your purchases.</h2>
      </div>
      <ul className="space-y-4" data-testid="orders-list">
        {orders.map((o, i) => (
          <motion.li
            key={o.order_no}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: Math.min(i, 8) * 0.04 }}
            className="bg-white border border-jow-navy/10 hover:border-jow-gold/60 transition-colors"
            data-testid={`orders-row-${o.order_no}`}
          >
            <Link to={`/account/orders/${o.order_no}`} className="flex items-center gap-5 p-5">
              <div className="flex -space-x-3">
                {o.items.slice(0, 3).map((it) => (
                  <img key={it.sku} src={it.image} alt="" className="w-12 h-12 object-cover border border-jow-cream" />
                ))}
              </div>
              <div className="flex-1">
                <p className="font-display text-lg text-jow-navy">{o.order_no}</p>
                <p className="text-xs text-jow-navy/55">
                  {new Date(o.created_at).toLocaleDateString()} · {o.items.length} items · ₹{o.total.toLocaleString("en-IN")}
                </p>
              </div>
              <span
                className="text-[10px] uppercase tracking-widest px-3 py-1 border"
                style={{ borderColor: STATUS_COLORS[o.status] || "#0A1F44", color: STATUS_COLORS[o.status] || "#0A1F44" }}
                data-testid={`orders-status-${o.order_no}`}
              >
                {o.status.replace("_", " ")}
              </span>
              <ChevronRight size={18} className="text-jow-navy/30" />
            </Link>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}
